<template>
  <div class="gc-translation-prompt">
    <label class="gc-translation-prompt__label" :for="inputId">
      {{ label }}
    </label>
    <v-textarea
      :id="inputId"
      :value="value"
      class="gc-translation-prompt__input"
      outlined
      dense
      hide-details
      dark
      auto-grow
      :rows="rows"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
    />
    <p class="gc-translation-prompt__hint">{{ hint }}</p>
  </div>
</template>

<script>
const UI_INFO_STORAGE_KEY = 'gc-translation-ui-info-config';

export { UI_INFO_STORAGE_KEY };

export default {
  name: 'TranslationPromptField',

  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'UI info config (optional)'
    },
    placeholder: {
      type: String,
      default: 'Paste info/default.json'
    },
    hint: {
      type: String,
      default: 'Optional layout context for translation.'
    },
    rows: {
      type: [Number, String],
      default: 2
    },
    persistKey: {
      type: String,
      default: UI_INFO_STORAGE_KEY
    }
  },

  computed: {
    inputId() {
      return `gc-translation-prompt-${this.persistKey}-${this._uid}`;
    }
  }
};

export function loadStoredTranslationField(key) {
  try {
    return sessionStorage.getItem(key) || '';
  } catch {
    return '';
  }
}

export function saveStoredTranslationField(key, value) {
  try {
    const text = String(value || '').trim();
    if (text) sessionStorage.setItem(key, value);
    else sessionStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export function loadStoredTranslationUiInfoConfig() {
  return loadStoredTranslationField(UI_INFO_STORAGE_KEY);
}

export function saveStoredTranslationUiInfoConfig(value) {
  saveStoredTranslationField(UI_INFO_STORAGE_KEY, value);
}
</script>
